module.exports = __webpack_public_path__ + "img/logo.4eabc8bc.svg";